import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

import {labels} from '../../../../../util/utils';
import {tagIcon} from '../../../../../util/svgIcons';

import ManageCustomTags from './ManageTags/TagsList';
import TagList from '../../../../Common/TagList';
import ManageTags from './ManageTags';
import StyledDropdown from '../StyledDropdown';
import StyledElement from './StyledElement';
import ToolbarButton from '../ToolbarButton';

const Tag = () => {
	const [listContacts, setListContacts] = useState({});
	const [show, setShow] = useState(false);

	const selectedContacts = useSelector((store) => store.contacts.selected);
	const entities = useSelector((store) => store.contacts?.entities);
	const tagsStore = useSelector((store) => store.project.tags);
	const {userGui, userList} = useSelector(({userPreferences, project}) => ({
		userGui: userPreferences?.gui,
		userList: project?.users
	}));

	useEffect(() => {
		let listState = {};
		entities.forEach((entity) => {
			entity?.contacts?.forEach((contact) => {
				if (selectedContacts.includes(contact.userId)) {
					contact?.tags?.forEach((tag) => {
						if (listState?.tags?.[tag?.id]) {
							listState.tags = {...listState?.tags, [tag?.id]: [...listState.tags?.[tag?.id], contact.userId]};
						} else {
							listState.tags = {...listState?.tags, [tag?.id]: [contact.userId]};
						}
					});
					listState[entity?.entityId] = [...(listState[entity?.entityId] ?? ''), contact?.userId];
				}
			});
		});
		setListContacts(listState);
	}, [selectedContacts, entities]);

	const renderTrigger = () => {
		const props = {
			svg: tagIcon,
			label: labels.toolbarTags
		};

		return <ToolbarButton {...props} />;
	};

	const renderContent = () => {
		const userData = userList?.find(({userId}) => userId === userGui);
		const isProjectOwner = !!userData?.isProjectOwner;

		return (
			<>
				<StyledElement className="customScrollbar">
					<TagList selectedTags={listContacts} tagsList={tagsStore} />
				</StyledElement>
				{isProjectOwner && <ManageTags setShow={setShow} />}
			</>
		);
	};

	const props = {
		placement: 'bottom-right',
		trigger: renderTrigger(),
		reversed: true,
		topfix: true
	};

	const modalProps = {
		showTagsModal: show,
		onModalOpen: () => setShow(true),
		onModalClose: () => setShow(false)
	};

	return (
		<>
			<StyledDropdown {...props}>{renderContent()}</StyledDropdown>
			{show && <ManageCustomTags {...modalProps} />}
		</>
	);
};

export default Tag;
